<template>
  <div>
    <v-container>
      <v-row dense>
        <v-col v-for="book in books" :key="book.isbn" class="py-1 book-info">
          <BookInfo :bookInfo="book"></BookInfo>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="reflesh-button-container">
      <v-btn class="justify-center" @click="updateBooksData()">
        本のタイトルをリフレッシュする
      </v-btn>
    </v-container>
  </div>
</template>

<script>
import { isbnKoudansha } from "../assets/isbn-koudansha";
import { getRandomSelect } from "../util/isbn-selector";
import { getBookInfo } from "../util/openbd";
import BookInfo from "../components/BookInfo.vue";

const MAX_COUNT = 35;
export default {
  name: "HomePage",
  components: {
    BookInfo,
  },
  data() {
    return {
      books: [
        {
          isbn: "1234567890123",
          title: "Happy!",
        },
      ]
    };
  },
  mounted() {
    this.updateBooksData();
  },
  methods: {
    async updateBooksData() {
      let bookList = [];
      console.log("updateBooksData");
      const isbns = getRandomSelect(isbnKoudansha, MAX_COUNT);
      isbns.forEach(async (isbn) => {
        const bookInfo = await getBookInfo(isbn);
        if ("title" in bookInfo) {
          bookList.push(bookInfo);
        }
      });
      this.books = bookList;
    },
  },
};
</script>

<style scoped>
.book-info {
    writing-mode: vertical-rl;
}
.reflesh-button-container {
  display: flex;
  justify-content: center;
}
</style>